import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate } from 'react-router';
import { endpoint } from '..';
import * as Alert from '../../../components/Alert/Alert';
import Button from '../../../components/Button/Button';
import { IInitialState } from '../../../reduxService';
import { useAppDispatch, useAppSelector } from '../../../reduxService/hooks';
import { IProjectMacra1 } from '../../MACRA_1/store/project/projectSlice';
import { IProjectMacra2 } from '../../MACRA_2/store/project/projectSlice';
import { getActionByProjectType } from '../../actionMap';
import Layout from '../../components/Layout/Layout';
import { EProjectType } from '../../enum/project';
import Macra1Icon from '../../images/MacRA-Design_ICONE_Channel-and-bank-protection.jpg';
import Macra2Icon from '../../images/MacRA-Design_ICONE_Grade-control-structures.jpg';
import { selectProjectInfo, setProjectInfo } from '../../store/projectInfo/projectInfoSlice';
import './ProjectType.scss';

const ProjectType = () => {
    const { t } = useTranslation();
    const projectInfo = useAppSelector(selectProjectInfo);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const { selectProject, cleanGeometry, cleanResults, cleanProject } = getActionByProjectType();
    const project: IInitialState<IProjectMacra1 | IProjectMacra2> = useAppSelector(selectProject as any);

    const [projectType, setProjectType] = React.useState<EProjectType>(projectInfo.data?.type ?? EProjectType.Macra1);

    if (projectInfo.initialState) {
        return <Navigate to={endpoint.home} replace={true} />;
    }

    const onClickMacra1 = (e: React.MouseEvent<HTMLButtonElement>) => {
        setProjectType(EProjectType.Macra1);
    };

    const onClickMacra2 = (e: React.MouseEvent<HTMLButtonElement>) => {
        setProjectType(EProjectType.Macra2 | EProjectType.VerticalDrop);
    };

    const handleClick = () => {
        const handleProjectTypeSelection = () => {
            dispatch(cleanResults());
            dispatch(cleanProject());
            dispatch(setProjectInfo({ ...projectInfo.data!, type: projectType }));
            navigate(endpoint.template);
        };

        if (!project.initialState && project.data) {
            Alert.warning(t('template_alert_title'), t('template_alert_body') as string, true).then(result => {
                if (result.isConfirmed) {
                    handleProjectTypeSelection();
                }
            });
        } else {
            handleProjectTypeSelection();
        }
    };

    return (
        <Layout>
            <section className='projectType-container h-100'>
                <div className='d-flex h-100 flex-column align-items-center justify-content-center overflow-auto'>
                    <div className='d-flex flex-column w-80 gap-3 min-height'>
                        <div className='buttons-wrapper d-flex gap-4 p-5'>
                            <Button
                                classNameBtn={`d-flex flex-column align-items-center gap-3 ${projectType === EProjectType.Macra1 ? 'btn-projectType-active' : 'btn-projectType'}`}
                                onClick={onClickMacra1}>
                                <img src={Macra1Icon} alt='Macra1 Icon' />
                                <h3>{t('project_type_protection')}</h3>
                                <p>{t('channel_bank_protection_description')}</p>
                            </Button>
                            <Button
                                classNameBtn={`d-flex flex-column align-items-center gap-3 ${
                                    projectType === (EProjectType.Macra2 | EProjectType.VerticalDrop) ? 'btn-projectType-active' : 'btn-projectType'
                                }`}
                                onClick={onClickMacra2}>
                                <img src={Macra2Icon} alt='Macra2 Icon' />
                                <h3>{t('project_type_structure')}</h3>
                                <p>{t('grade_control_structore_description')}</p>
                            </Button>
                        </div>
                        <Button className='d-flex justify-content-end mt-1' onClick={handleClick}>
                            {t('next_button')}
                        </Button>
                    </div>
                </div>
            </section>
        </Layout>
    );
};

export default ProjectType;
